import { Box, Button, CircularProgress } from "@mui/material";

import { Colors, GreyPallet } from "../../config/styles";

import theme from "../../config/Theme";
import MainText from "../MainText";

type ComponetProps = {
  text?: string;
  loading?: boolean;
  icon?: JSX.Element;
  onClick?: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
  color?:
    | "black"
    | "default"
    | "white"
    | "grey"
    | "danger"
    | "error"
    | "info"
    | "success"
    | "warning";
  textColor?: "black" | "white" | "danger" | "grey";
  small?: boolean;
  noIconMargin?: boolean;
};

export default function MainSolidButton({
  text,
  loading,
  icon,
  onClick,
  disabled,
  fullWidth = true,
  color = "black",
  textColor,
  small,
  noIconMargin,
  ...props
}: ComponetProps) {
  const customBackgroundColor =
    color === "error" || color === "danger"
      ? Colors.Danger
      : color === "grey"
      ? GreyPallet.Light
      : color === "info"
      ? theme.palette.info.main
      : color === "success"
      ? theme.palette.success.main
      : color === "warning"
      ? theme.palette.warning.main
      : "#000";

  const customTextColor = textColor ? textColor : color === "grey" ? GreyPallet.LightGhost : "#fff";

  return (
    <Button
      {...props}
      disabled={disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      style={{
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        height: small ? 40 : 60,
        borderRadius: "15px",
        textTransform: "none",
        backgroundColor: customBackgroundColor,
        color: customTextColor,
      }}
    >
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        {color === "grey" ? (
          loading ? (
            <Box
              style={{ marginLeft: noIconMargin ? 0 : 12, width: "26px" }}
              display={"flex"}
              alignItems={"center"}
            >
              <CircularProgress size={"20px"} color="inherit" />
            </Box>
          ) : icon ? (
            <Box
              style={{ marginLeft: noIconMargin ? 0 : 12, width: "26px" }}
              display={"flex"}
              alignItems={"center"}
              sx={{ "& .MuiSvgIcon-root": { color: "#000" } }}
            >
              {icon}
            </Box>
          ) : null
        ) : null}

        <MainText color={color === "grey" ? "regular" : "white"}>{text}</MainText>

        {color !== "grey" ? (
          loading ? (
            <Box
              style={{ marginLeft: noIconMargin ? 0 : 12, width: "26px" }}
              display={"flex"}
              alignItems={"center"}
            >
              <CircularProgress size={"20px"} color="inherit" />
            </Box>
          ) : icon ? (
            <Box
              style={{ marginLeft: noIconMargin ? 0 : 12, width: "26px" }}
              display={"flex"}
              alignItems={"center"}
              sx={{ "& .MuiSvgIcon-root": { color: "inherit" } }}
            >
              {icon}
            </Box>
          ) : null
        ) : null}
      </Box>
    </Button>
  );
}
